import { combineReducers } from 'redux'

import tipoContrato from './tipoContrato'
import objetoLicitacao from './objetoLicitacao'
import situacaoLegal from './situacaoLegal'
import classificacao from './classificacao'
import tipoObra from './tipoObra'
import tipoNaturezaObra from './tipoNaturezaObra'
import fonte from './fonte'

export default combineReducers({ objetoLicitacao, tipoContrato, situacaoLegal, classificacao, tipoObra, tipoNaturezaObra, fonte })
